import { AppMaterialModule } from 'src/app/app.material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import { NgxMaskModule } from 'ngx-mask';
import { HttpClientInterceptor } from './_utils/http-client.intercepter';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MenuAsideService } from './_metronic/layout/core/menu-aside.service';
import { MenuConfigService } from './_metronic/layout/core/menu-config.service';
import { PosCustomerDisplayComponent } from './pos-customer-display/pos-customer-display.component';
import { AlertModule } from './pos/services/alert/alert.module';
import { HotToastModule } from '@ngneat/hot-toast';
import { PinRecoveryComponent } from './pin-recovery/pin-recovery.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareModule } from './pos/shares/share.module';
import { DatePipe } from '@angular/common';

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [AppComponent, PosCustomerDisplayComponent, PinRecoveryComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ClipboardModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    NgxMaskModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    AlertModule,
    HotToastModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgbCarouselModule,
    ShareModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpClientInterceptor,
      multi: true,
    },
    MenuAsideService,
    MenuConfigService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
